export default __webpack_public_path__ + "static/soccer-715155902904d6ede5105579f71330ba.png";